<template>
  <b-row class="step group" :class="{ 'invalid-field': invalidField }">
    <header class="col col-md-9 d-flex flex-wrap flex-lg-nowrap">
      <div class="group-text-box flex flex-grow-1 mr-2 mt-1">
        <div class="number">1</div>
        <span class="text-primary medium">{{ labels.groupHeader }}</span>
      </div>

      <div
        class="group-options-box flex flex-lg-shrink-0 mt-1"
        :class="{ 'd-none': isManager }"
      >
        <Switches
          v-model="toCompany"
          class="mb-0 mr-3"
          type-bold="true"
          theme="custom"
          color="primary"
          :disabled="isEdit"
        />
        <span
          v-if="!isEdit"
          class="clickable"
          @click="setToCompany(!toCompany)"
        >
          {{ labels.toCompany }}
        </span>
        <span class="clickable" v-else>
          {{ labels.toCompany }}
        </span>
      </div>
    </header>
    <b-collapse
      id="groupCollapse"
      class="col-md-9 mt-3"
      :visible="!toCompany && !isEdit"
    >
      <div class="form-group">
        <v-select
          label="name"
          :placeholder="labels.selectGroup"
          :value="groupSelected"
          :options="groupList"
          @input="({ _id }) => _id && $emit('setGroupId', _id)"
        />
      </div>
    </b-collapse>
  </b-row>
</template>
<script>
import { isManager } from '@/service/user'
export const COMPANY = 'company'

export default {
  components: {
    Switches: () => import('vue-switches'),
    vSelect: () => import('vue-select'),
  },
  props: {
    invalidField: {
      type: Boolean,
    },
    groupId: {
      type: [String, Number],
    },
    groupList: {
      type: Array,
      required: true,
    },
    isEdit: {
      type: Boolean,
    },
  },
  data() {
    return {
      toCompany: false,
    }
  },
  created() {
    this.groupId === COMPANY && this.setToCompany(true)
  },
  computed: {
    labels() {
      const labels = this.$store.getters.resources.component.actionPlan
        .formGroup
      const groupSelectedLabel = this.groupSelected
        ? this.groupSelected.name
        : labels.company
      const groupHeader = this.groupId
        ? `${labels.groupSelected} ${groupSelectedLabel}`
        : labels.addGroup

      return {
        ...labels,
        groupHeader,
      }
    },
    groupSelected() {
      return this.groupList
        .filter(({ _id }) => _id === this.groupId)
        .reduce((defaultGroup, group) => group || defaultGroup, null)
    },
    isManager() {
      return isManager()
    },
  },
  watch: {
    toCompany: {
      handler: 'setToCompany',
    },
  },
  methods: {
    setToCompany(value) {
      this.toCompany = value

      this.toCompany
        ? this.$emit('setGroupId', COMPANY)
        : this.$emit('setGroupId', undefined)
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~@/styles/custom/mixins';

/deep/ .v-select {
  .vs__search {
    color: map-get($theme-colors, 'gray01') !important;
  }

  .vs__dropdown-toggle {
    height: 48px;
  }
}

.invalid-field /deep/ .v-select .vs__dropdown-toggle {
  @include setInvalidInputStyle;
}

/deep/ .vue-switcher--bold div {
  top: 0;
}
</style>
